/**
 * FOOTRA Ajax Cart Drawer (Pakistan Edition - PKR)
 */

class CartDrawerManager {
  constructor() {
    this.freeShippingThreshold = 3500;
    this.drawer = document.querySelector('.cart-drawer');
    this.overlay = document.querySelector('.cart-drawer-overlay');
    this.itemsContainer = document.querySelector('.drawer-items-list');
    this.subtotalEl = document.querySelector('[data-drawer-subtotal]');
    this.meterText = document.querySelector('[data-shipping-meter-text]');
    this.meterFill = document.querySelector('[data-shipping-meter-fill]');
    this.cartCountBadges = document.querySelectorAll('.cart-count-badge');
    
    this.demoCart = {
      items: [
        {
          id: 101,
          title: "FOOTRA Tan Leather Comfort Slide",
          variant: "Onyx Black / Size 9 (EU 42)",
          price: 1899,
          quantity: 1,
          image: "assets/slide-tan-leather.jpg"
        }
      ],
      total_price: 1899
    };

    this.init();
  }

  init() {
    this.bindEvents();
    this.render();
  }

  bindEvents() {
    document.querySelectorAll('[data-cart-trigger]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.open();
      });
    });

    document.querySelectorAll('[data-drawer-close]').forEach(btn => {
      btn.addEventListener('click', () => this.close());
    });

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.close());
    }

    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (form && form.action && form.action.includes('/cart/add')) {
        e.preventDefault();
        this.handleAddForm(form);
      }
    });

    const upsellBtn = document.querySelector('[data-upsell-add]');
    if (upsellBtn) {
      upsellBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.addItem({
          id: 999,
          title: "FOOTRA Shoe Cleaner & Shield Kit",
          variant: "Standard Kit (150ml)",
          price: 799,
          quantity: 1,
          image: "https://images.unsplash.com/photo-1585386959984-a4155224a1ad?q=80&w=300&auto=format&fit=crop"
        });
        upsellBtn.textContent = "Added ✓";
        upsellBtn.disabled = true;
        setTimeout(() => {
          upsellBtn.textContent = "+ Add (Rs. 799)";
          upsellBtn.disabled = false;
        }, 2000);
      });
    }

    document.querySelectorAll('[data-quick-add]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const title = btn.getAttribute('data-product-title') || "FOOTRA Slide";
        const priceStr = (btn.getAttribute('data-product-price') || "2999").replace(/,/g, '');
        const price = parseFloat(priceStr) || 2999;
        const image = btn.getAttribute('data-product-image') || "assets/slide-tan-leather.jpg";
        this.addItem({
          id: Date.now(),
          title: title,
          variant: "Onyx Black / Size 9",
          price: price,
          quantity: 1,
          image: image
        });
      });
    });
  }

  open() {
    this.drawer?.classList.add('active');
    this.overlay?.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer?.classList.remove('active');
    this.overlay?.classList.remove('active');
    document.body.style.overflow = '';
  }

  handleAddForm(form) {
    const formData = new FormData(form);
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(res => res.json())
    .then(() => {
      this.fetchShopifyCart();
    })
    .catch(() => {
      const title = document.querySelector('.pdp-title')?.textContent || "FOOTRA Cloud Slide";
      const size = document.querySelector('.size-pill-btn.selected')?.getAttribute('data-size') || "Size 9 (EU 42)";
      const color = document.querySelector('.color-swatch-btn.selected')?.getAttribute('data-color') || "Onyx Black";
      const mainImage = document.querySelector('[data-pdp-main-image]')?.src || "assets/slide-tan-leather.jpg";

      this.addItem({
        id: Date.now(),
        title: title.trim(),
        variant: `${color} / ${size}`,
        price: 1899,
        quantity: 1,
        image: mainImage
      });
    });
  }

  fetchShopifyCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        this.demoCart = {
          items: cart.items.map(i => ({
            id: i.id,
            title: i.product_title,
            variant: i.variant_title,
            price: i.price / 100,
            quantity: i.quantity,
            image: i.image
          })),
          total_price: cart.total_price / 100
        };
        this.render();
        this.open();
      })
      .catch(() => {
        this.render();
        this.open();
      });
  }

  addItem(item) {
    const existing = this.demoCart.items.find(i => i.title === item.title && i.variant === item.variant);
    if (existing) {
      existing.quantity += item.quantity;
    } else {
      this.demoCart.items.push(item);
    }
    this.render();
    this.open();
  }

  updateQuantity(id, delta) {
    const item = this.demoCart.items.find(i => i.id === id);
    if (!item) return;
    item.quantity += delta;
    if (item.quantity <= 0) {
      this.demoCart.items = this.demoCart.items.filter(i => i.id !== id);
    }
    this.render();
  }

  render() {
    if (!this.itemsContainer) return;

    let subtotal = 0;
    let totalCount = 0;

    if (this.demoCart.items.length === 0) {
      this.itemsContainer.innerHTML = `
        <div style="text-align: center; padding: 40px 20px; color: var(--color-text-muted);">
          <p style="font-size: 1.1rem; font-weight: 700; margin-bottom: 8px;">Aapka bag abhi khaali hai.</p>
          <p style="font-size: 0.9rem;">Experience weightless cloud comfort today.</p>
          <button class="btn btn-primary" style="margin-top: 20px;" data-drawer-close>Shop Footwear</button>
        </div>
      `;
      const closeBtn = this.itemsContainer.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', () => this.close());
    } else {
      this.itemsContainer.innerHTML = this.demoCart.items.map(item => {
        const itemTotal = item.price * item.quantity;
        subtotal += itemTotal;
        totalCount += item.quantity;

        return `
          <div class="cart-item" data-item-id="${item.id}">
            <img src="${item.image}" alt="${item.title}" class="cart-item-img">
            <div class="cart-item-info">
              <div>
                <div class="cart-item-name">${item.title}</div>
                <div class="cart-item-variant">${item.variant || 'Standard'}</div>
              </div>
              <div class="cart-item-bottom">
                <div class="quantity-stepper">
                  <button class="stepper-btn" data-stepper-minus="${item.id}">-</button>
                  <span class="stepper-val">${item.quantity}</span>
                  <button class="stepper-btn" data-stepper-plus="${item.id}">+</button>
                </div>
                <span class="cart-item-price">Rs. ${itemTotal.toLocaleString()}</span>
              </div>
            </div>
          </div>
        `;
      }).join('');

      this.itemsContainer.querySelectorAll('[data-stepper-minus]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = Number(btn.getAttribute('data-stepper-minus'));
          this.updateQuantity(id, -1);
        });
      });

      this.itemsContainer.querySelectorAll('[data-stepper-plus]').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = Number(btn.getAttribute('data-stepper-plus'));
          this.updateQuantity(id, 1);
        });
      });
    }

    if (this.subtotalEl) {
      this.subtotalEl.textContent = `Rs. ${subtotal.toLocaleString()}`;
    }

    this.cartCountBadges.forEach(b => {
      b.textContent = totalCount;
    });

    const threshold = this.freeShippingThreshold;
    const remaining = threshold - subtotal;
    const percentage = Math.min(100, Math.max(0, (subtotal / threshold) * 100));

    if (this.meterFill) {
      this.meterFill.style.width = `${percentage}%`;
    }

    if (this.meterText) {
      if (remaining <= 0) {
        this.meterText.innerHTML = `<span>🎉 Mubarak! You unlocked FREE Delivery Across Pakistan!</span>`;
      } else {
        this.meterText.innerHTML = `You are <span>Rs. ${remaining.toLocaleString()}</span> away from <strong>FREE Delivery</strong>!`;
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.cartDrawer = new CartDrawerManager();
});
